import { Component, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface PromptDialogData {
  title: string;
  message?: string;
  label: string;
  required?: boolean;
  confirmLabel?: string;
  confirmColor?: 'primary' | 'warn' | 'accent';
}

@Component({
  selector: 'app-prompt-dialog',
  template: `
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <mat-dialog-content>
      <p *ngIf="data.message" class="text-muted mb-3">{{ data.message }}</p>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ data.label }}</mat-label>
        <textarea matInput [formControl]="input" rows="3" cdkFocusInitial></textarea>
        <mat-error *ngIf="input.hasError('required')">{{ data.label }} is required</mat-error>
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-stroked-button (click)="cancel()">Cancel</button>
      <button mat-raised-button
              [color]="data.confirmColor || 'primary'"
              [disabled]="data.required && input.invalid"
              (click)="confirm()"
              class="ms-2">
        {{ data.confirmLabel || 'Confirm' }}
      </button>
    </mat-dialog-actions>
  `,
})
export class PromptDialogComponent {
  input: FormControl;

  constructor(
    public dialogRef: MatDialogRef<PromptDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PromptDialogData
  ) {
    this.input = new FormControl('', data.required ? [Validators.required] : []);
  }

  confirm(): void {
    if (this.data.required && this.input.invalid) {
      this.input.markAsTouched();
      return;
    }
    this.dialogRef.close(this.input.value || '');
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
